webpackJsonp([212839066777427],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Author = __webpack_require__(144);
	
	var _Author2 = _interopRequireDefault(_Author);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var entry = _ref.entry;
	
	  var Avatar = (0, _Author2.default)(entry.author);
	  return _react2.default.createElement(
	    "div",
	    { className: "c-blog--slat" },
	    _react2.default.createElement(
	      "div",
	      { className: "c-blog--date" },
	      entry.date
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-pull-right" },
	      _react2.default.createElement(Avatar, null)
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "c-blog--title h3 a--underline" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: entry.uri },
	        entry.title
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "c-blog--summary" },
	      entry.excerpt
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlogSlat = __webpack_require__(192);
	
	var _BlogSlat2 = _interopRequireDefault(_BlogSlat);
	
	var _reactHelmet = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var posts = [];
	  data.allMarkdownRemark.edges.forEach(function (_ref2) {
	    var node = _ref2.node;
	
	    posts.push({
	      excerpt: node.excerpt,
	      title: node.frontmatter.title,
	      date: node.frontmatter.date,
	      uri: node.fields.slug,
	      author: node.frontmatter.author
	    });
	  });
	  data.allPostsJson.edges.forEach(function (_ref3) {
	    var node = _ref3.node;
	
	    posts.push({
	      excerpt: node.excerpt,
	      title: node.title,
	      date: node.date,
	      uri: node.page + "/",
	      author: node.author
	    });
	  });
	  posts.sort(function (a, b) {
	    return a.date < b.date ? 1 : -1;
	  });
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Limenius. Blog about development."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "template" },
	      _react2.default.createElement(
	        "div",
	        { className: "o-title--lettering o-lettering--container" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-lettering o-lettering__ultra" },
	            "Something to tell"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "content container-sm" },
	        _react2.default.createElement(
	          "div",
	          { className: "c-blog--index" },
	          _react2.default.createElement(
	            "div",
	            { className: "u-guttered" },
	            posts.map(function (entry, idx) {
	              return _react2.default.createElement(
	                "div",
	                { key: idx },
	                _react2.default.createElement(_BlogSlat2.default, { entry: entry }),
	                _react2.default.createElement("hr", null)
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-d5ac0a253f5ea838b1f1.js